import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Button, ButtonContainer, Grid, Typography } from '@emburse/embark-core';
import { Drawer } from '../../../../components';
import { $t, useTranslation } from '../../../../hooks/useTranslation';
const CorpDataInterchangeConfigDrawer = forwardRef(({ title, onSave, children }, ref) => {
    useTranslation();
    const [showDrawer, setShowDrawer] = useState(false);
    useImperativeHandle(ref, () => ({
        setDrawerState(bool) {
            setShowDrawer(bool);
        }
    }));
    return (_jsx(Drawer, { open: showDrawer, anchor: "right", sideWidth: 448, openUpdated: setShowDrawer, title: _jsx(Typography, { variant: "h5", gutterBottom: true, children: title }), footer: _jsx(Grid, { container: true, justifyContent: "flex-end", children: _jsx(Grid, { item: true, style: { marginTop: 'auto' }, children: _jsxs(ButtonContainer, { alignButtons: "right", children: [_jsx(Button, { color: "primary", variant: "outlined", onClick: () => setShowDrawer(false), children: title === $t('Additional Attributes')
                                ? $t('Cancel')
                                : $t('Close') }), title === $t('Additional Attributes') && (_jsx(Button, { color: "primary", onClick: onSave, children: "Save" }))] }) }) }), children: children }));
});
export default CorpDataInterchangeConfigDrawer;
